import React, { useEffect, useState, useContext } from 'react';
import { Snackbar, Slide, Button } from '@mui/material';
import { UserContext } from '../assets/contexts/userContext';
import { lightTheme } from '../theme/lightTheme';


function SlideUp(props) {
  return <Slide {...props} direction="up" />;
}

const CookieModal = () => {
  const { user } = useContext(UserContext);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookiesAccepted');
    const timestamp = localStorage.getItem('cookiesAcceptedTimestamp');
    const now = Date.now();
    const expiryTime = 2 * 60 * 60 * 1000; // 2 hours

    if (user.isLogged) {
      setOpen(false);
    } else if (!accepted) {
      setOpen(true);
    } else if (timestamp && now - Number(timestamp) > expiryTime) {
      setOpen(true);
    }
  }, [user.isLogged]);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    localStorage.setItem('cookiesAcceptedTimestamp', Date.now().toString());
    setOpen(false);
  };

  if (!open || user.isLogged) return null;

  return (
    <Snackbar
      open={open}
      onClose={handleAccept}
      message="Utilizamos cookies para mejorar la experiencia de usuario."
      TransitionComponent={SlideUp}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      action={
        <Button
          variant="contained"
         sx={{ backgroundColor: lightTheme.palette.primary.main,
              '&:hover': { backgroundColor: lightTheme.palette.primary.dark }
             }}
          onClick={handleAccept}
        >
          Aceptar
        </Button>
      }
      sx={{
        '& .MuiSnackbarContent-root': {
          flexWrap: 'nowrap',
          width: '100%',
          maxWidth: 600,
        },
      }}
    />
  );
};

export default CookieModal;
